import React from "react";
import BeppoLogo from "../../common/assets/beppo-logo-119x47.svg";
import Style from "./headingWithBeppoLogo.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import LanguageMenu from "../../reusable/languageMenu";
import { useAvailableLanguages } from "../../util/internationalization";

interface HeadingWithBeppoLogoProps {
  visibleTranslate: boolean;
}

const HeadingWithBeppoLogo = (props: HeadingWithBeppoLogoProps) => {
  const [openMenu, setOpenMenu] = useState(false);
  const menu = () => {
    setOpenMenu(!openMenu);
  };
  const availableLanguages = useAvailableLanguages();


  const closeMenu = () => {
    setOpenMenu(false);
  };
  const changeLanguageLabel = (label: string) => {
    setLanguage(label);
  };

  const { i18n } = useTranslation();

  const [language, setLanguage] = useState(i18n.language.toUpperCase());

  return (
    <div className={Style.headingWithBeppoLogo}>
      <div className={Style.hairlineHeading}></div>
      <div className={Style.imgTranslateContainer}>
        <div>
          <img src={BeppoLogo} id="beppoLogo" alt="beppo-logo" height={50} />
        </div>
        {props.visibleTranslate && (
          <div onClick={menu} className={Style.languageSwitchContainer}>
            <div className={Style.currentLanguage}>
              <FontAwesomeIcon icon={openMenu ? faAngleUp : faAngleDown} />
              <div>{language}</div>
            </div>
            {openMenu && (
              <LanguageMenu
                style={{ marginTop: "40px" }}
                closeMenu={closeMenu}
                changeLanguageLabel={changeLanguageLabel}
                availableLanguages={availableLanguages}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

HeadingWithBeppoLogo.defaultProps = {
  visibleTranslate: false,
};

export default HeadingWithBeppoLogo;
